<template>
  <div class="exam">
    <div class="container">
      <div
        v-if="questionsData.length || courseType === 2"
        class="exam-container"
      >
        <div id="examMain" class="exam-main">
          <div class="exam-main__title">
            {{ $t('exam.examDate') }}：
            {{ data.examinationStartDate | toTaipei | moment('YYYY/MM/DD HH:mm:ss') }}
          </div>
          <div class="exam-main__content">
            <div :key="currentTopic.questionId" class="exam-question">
              <div class="exam-question__tool">
                <span>{{ currentTopic.questionTypeName }}</span>
              </div>

              <div class="exam-question__title">
                <p v-html="convertBreakLine(currentTopic.questionName)" />
              </div>
              <div
                v-if="currentTopic.questionAudioPath || currentTopic.questionImagePath"
                class="exam-question__content"
              >
                <div
                  v-if="currentTopic.questionAudioPath"
                  class="exam-question__audio"
                >
                  <audio controls>
                    <source :src="currentTopic.questionAudioPath" />
                  </audio>
                </div>

                <div
                  v-if="currentTopic.questionImagePath"
                  class="exam-question__image"
                >
                  <img :src="currentTopic.questionImagePath" alt="">
                </div>
              </div>

              <div class="exam-question__list">
                <template v-for="(item, index) in currentTopic.answers">
                  <el-checkbox
                    v-if="item.answerName !== ''"
                    v-model="item.isAnswer"
                    :key="item.answerId"
                    :true-label="1"
                    :false-label="0"
                    :disabled="true"
                    class="exam-question__option"
                    :class="{
                      'exam-question__option--error': isErrorAnswer(item),
                      'exam-question__option--correct': isTrueAnswer(item) || isCorrectAnswer(item),
                    }"
                  >
                    <span v-if="isTrueAnswer(item)">({{ $t('exam.trueAnswer') }})</span>
                    <i
                      v-if="isCorrectAnswer(item)"
                      class="fa fa-check-circle"
                      :style="{ color: '#62df68 ' }"
                    />
                    <i
                      v-if="isErrorAnswer(item)"
                      class="fa fa-times-circle"
                      :style="{ color: '#ff6363' }"
                    />

                    ({{ index + 1 }}) {{ item.answerName }}
                  </el-checkbox>
                </template>
              </div>

              <div class="exam-explain">
                <div
                  class="exam-explain__head"
                  @click="explainShow = !explainShow"
                >
                  <div>
                    <i
                      class="el-alert__icon"
                      :class="{
                        'el-icon-info': !currentTopic.questionsNote,
                        'el-icon-circle-plus': currentTopic.questionsNote && !explainShow,
                        'el-icon-remove': currentTopic.questionsNote && explainShow,
                      }"
                    />

                    <span>
                      {{ currentTopic.questionsNote ? $t('exam.viewExplanation') : $t('exam.noExplanation') }}
                    </span>

                    <font v-if="currentTopic.questionAuthor">
                      - {{ currentTopic.questionAuthor }}
                    </font>
                  </div>

                  <span v-if="getCorrectOfTotal">
                    {{ getCorrectOfTotal }}
                  </span>
                </div>

                <div
                  v-if="explainShow && currentTopic.questionsNote"
                  class="exam-explain__content"
                  v-html="currentTopic.questionsNote"
                />
              </div>

              <div class="exam-question__buttonBox">
                <a
                  v-if="questionIndex !== 0"
                  class="exam-question__prev"
                  @click="handlePrevTopic"
                >
                  <span>{{ $t('exam.button.previous') }}</span>
                </a>

                <a
                  v-if="data.questions && questionIndex < data.questions.length - 1"
                  class="exam-question__next"
                  @click="handleNextTopic()"
                >
                  <span>{{ $t('exam.button.next') }}</span>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class="exam-list">
          <div class="exam-list__title">{{ $t('exam.questionList') }}</div>
          <div class="exam-sidebar__tabs">
            <button
              class="exam-sidebar__tab"
              :class="{ 'exam-sidebar__tab--active': courseType === 1 }"
              @click="courseType = 1"
            >
              <i class="el-icon-notebook-2"></i>
              <span>{{ $t('exam.questionList') }}</span>
            </button>
            <button
              class="exam-sidebar__tab"
              :class="{ 'exam-sidebar__tab--active': courseType === 2 }"
              @click="courseType = 2"
            >
              <i class="el-icon-warning"></i>
              <span>{{ $t('exam.wrongQuestions') }}</span>
            </button>
          </div>

          <div
            v-if="questionsData.length"
            class="exam-list__summary"
          >
            <i class="fa fa-th" aria-hidden="true" />
            <span>{{ summaryTime }}</span>
            <span>{{ summaryRate }}</span>
          </div>

          <div class="exam-list__content">
            <template v-if="questionsData.length">
              <div
                v-for="(item, index) in questionsData"
                :key="`${index}-${item.questionCode}`"
                class="exam-list__item"
                :class="{'exam-list__item--active': item.seq - 1 === questionIndex}"
              >
                <a
                  class="exam-list__item-text"
                  @click="handleShowTopic(item, item.seq - 1)"
                >
                  <i
                    v-if="item.isTrueAnswer === false"
                    class="fa fa-times-circle"
                    style="color: red;"
                  />

                  <i
                    v-else
                    class="fa fa-check-circle"
                    :style="{ color: item.isTrueAnswer ? '#cccf2d' : '#c0c4cc' }"
                  />

                  <span>{{ $t('exam.currentQuestion', { current: item.seq }) }}</span>
                </a>

                <div class="exam-list__item-score">
                  <span>{{ $t('exam.questionScore', { score: item.questionScore, maxScore: item.questionOriScore }) }}</span>
                </div>
              </div>
            </template>

            <p v-else>{{ $t('exam.noData') }}</p>
          </div>
        </div>
      </div>

      <div
        v-else
        class="exam-empty"
      >
        <i class="el-icon-document-delete"></i>
        <p>{{ $t('exam.noAnswerRecord') }}</p>
      </div>

      <div class="exam-actions form">
        <router-link
          class="btn-submit"
          :to="`/practices/examHistory/${this.courseId}/${this.subjectId}`"
        >
          <i class="el-icon-back"></i>
          {{ $t('exam.returnToList') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { GetPracticeBreadcrumb } from '@/api/BuyPracticeApi';
import { GetExaminationById } from '@/api/MemberExamination';

/* global $ */
export default {
  props: ['currentPage'],
  data() {
    return {
      courseId: 0,
      subjectId: 0,
      courseType: 1,
      showTopic: false,
      data: {},
      currentTopic: {
        isFavorite: false,
        isMarkAnswer: false,
        isTrueAnswer: false,
        questionCode: '',
        questionId: 0,
        questionName: '',
        questionType: 0,
        questionTypeName: '',
        questionImagePath: '',
        questionAudioPath: '',
        questionsNote: '',
        recordNoteCount: 0,
        answers: [],
      },

      questionIndex: 0,
      explainShow: false,
    };
  },
  created() {
    this.GetAll();
  },
  computed: {
    summaryTime() {
      return this.$t('exam.testTime', { duration: this.data.questionTime });
    },
    summaryRate() {
      return this.$t('exam.errorRate', { current: this.data.questionIncorrect, total: this.data.questionTotal });
    },
    questionsData() {
      const tmpQuestions = this._.filter(this.data.questions,
        (item) => this.courseType === 1
          || (this.courseType === 2 && item.isTrueAnswer === false));

      return tmpQuestions;
    },
    getCorrectOfTotal() {
      const { responderCorrect, responderTotal } = this.currentTopic;

      if (responderCorrect && responderTotal) {
        return this.$t('exam.responderCorrectRate', { correctCount: responderCorrect, totalCount: responderTotal });
      }

      return '';
    },
  },
  methods: {
    GetPracticeBreadcrumb() {
      return new Promise((resolve, reject) => {
        const data = {
          courseId: this.courseId,
          subjectId: this.subjectId,
        };

        GetPracticeBreadcrumb(data)
          .then((response) => {
            if (response.data.statusCode === 0) {
              if (!this._.isEmpty(response.data.data)) {
                this.$emit('update:currentPage', [
                  {
                    name: 'learnings',
                    title: this.$t('route.title.myCourses'),
                    path: '',
                  },
                  {
                    name: 'learning',
                    title: `${response.data.data.courseName}`,
                    path: `/learning/${response.data.data.courseId}`,
                  },
                  {
                    name: 'practices',
                    title: this.$t('route.title.exam'),
                    path: `/practices/${response.data.data.courseId}`,
                  },
                  {
                    name: 'examHistory',
                    title: `${response.data.data.subjectName}`,
                    path: `/examHistory/${response.data.data.courseId}/${response.data.data.subjectId}`,
                  },
                ]);
              }
            }

            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
    GetAll() {
      this.courseId = this.$route.params?.id;
      this.subjectId = this.$route.params?.subjectId;

      if (!this.courseId || !this.subjectId) {
        this.$message({
          type: 'error',
          message: this.$t('exam.message.recordNotFound'),
        });

        return;
      }

      this.GetPracticeBreadcrumb()
        .then(() => {
          this.GetExaminationById();
        })
        .catch(() => {
          this.$router.replace('/error').catch();
        });
    },
    // 取得所有題目
    GetExaminationById() {
      const id = this.$route.params?.examId;

      GetExaminationById(id)
        .then((response) => {
          if (response.data.statusCode === 0) {
            this.data = this._.cloneDeep(response.data.data);

            this._.forEach(this.data.questions, (item) => {
              this._.sortBy(item.answers, ['answerId']);
            });

            this.handleShowTopic(this.data.questions[0], 0);
          }
        })
        .catch(() => {
          this.$router.replace('/error').catch();
        });
    },
    // 顯示選擇的題目在畫面上
    handleShowTopic(topic, index) {
      this.showTopic = true;
      // 清空作答
      this.currentTopic = this._.cloneDeep(topic);
      this.questionIndex = index;
      this.explainShow = false;

      this.$nextTick(() => {
        $('.exam-list__content').animate({
          scrollTop: 48 * this.questionIndex,
        }, 0);

        if ($(window).width() < 992) {
          $('html, body').animate({
            scrollTop: $('#examMain').offset().top - 62,
          }, 0);
        }
      });
    },
    handlePrevTopic() {
      const index = this.data.questions[this.questionIndex - 1].seq - 1;
      const topic = this._.cloneDeep(this.data.questions[this.questionIndex - 1]);

      this.handleShowTopic(topic, index);
    },
    handleNextTopic() {
      const index = this.data.questions[this.questionIndex + 1].seq - 1;
      const topic = this._.cloneDeep(this.data.questions[this.questionIndex + 1]);

      this.handleShowTopic(topic, index);
    },
    isErrorAnswer(item) {
      if (this.currentTopic.responderAnswers.length === 0) {
        return false;
      }

      return item.isAnswer !== 1
        && this._.includes(this.currentTopic.responderAnswers, item.answerId);
    },
    isTrueAnswer(item) {
      if (this.currentTopic.responderAnswers.length === 0) {
        return false;
      }

      return item.isAnswer === 1
        && !this._.includes(this.currentTopic.responderAnswers, item.answerId);
    },
    isCorrectAnswer(item) {
      if (this.currentTopic.responderAnswers.length === 0) {
        return false;
      }

      return item.isAnswer === 1
        && this._.includes(this.currentTopic.responderAnswers, item.answerId);
    },
    convertBreakLine(text) {
      if (this._.isEmpty(text)) {
        return '';
      }

      return text.replaceAll('\n', '<br>');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_exam.scss';

// ExamReview 特定樣式
.exam-question {
  margin-bottom: 40px;

  &:last-child {
    margin-bottom: 0;
  }

  &__option {
    &--error {
      border-color: #f56c6c;
      background-color: #fef0f0;
    }

    &--correct {
      border-color: #67c23a;
      background-color: #f0f9eb;
    }
  }
}

.exam-explain {
  margin-top: 24px;
  padding: 16px;
  background-color: var(--background-base);
  border-left: 4px solid var(--primary-color);
  border-radius: var(--border-radius-base);

  &__head {
    font-size: 15px;
    font-weight: 600;
    color: var(--primary-color);
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    i {
      font-size: 16px;
    }
  }

  &__content {
    font-size: 14px;
    line-height: 1.8;
    color: var(--text-regular);

    p {
      margin: 0;
    }
  }
}
</style>
